/**
 * Templates tab on dashboard's sidebar
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Checkbox } from 'wix-style-react'
import * as _ from 'lodash'

import DashboardTab from './DashboardTab'
import DashboardCard from './DashboardCard'
import * as templateCategory from '../../constants/templateCategory'
import * as integrationType from '../../constants/integrationType'
import TemplatesTypeSelector from './templatesTab/TemplatesTypeSelector'

const FiltersContainer = styled.div`
  width: 100%;
  height: 2.5em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 20px;
`
const StyledCheckbox = styled.div`
  margin-right: 1em;
`

const filters = [
  { id: 0, title: 'Instant Landing Apps' },
  { id: 1, title: 'Instagram Store templates' },
  /*{ id: 2, title: 'Shopify enabled' }*/
]

class TemplatesTab extends Component {

  constructor (props) {
    super(props)
    this.state = {
      activeFilters: [1],
      templates: this.filterTemplates(props.activeFilters, props.templates),
      templatesTypeChoosen: false
    }
  }

  filterTemplates (activeFilters, templates) {
    if (_.isEmpty(activeFilters)) return templates
    const filterIdEnabled = id => activeFilters.indexOf(id) > -1
    const res = []
    for (const t of templates) {
      let needed = false
      if (t.integrations.indexOf(integrationType.SHOPIFY) > -1) needed = filterIdEnabled(2)
      if (t.category === templateCategory.INSTAGRAM_SHOPPABLE) {
        needed = needed || filterIdEnabled(1)
      } else {
        needed = needed || filterIdEnabled(0)
      }
      if (needed) res.push(t)
    }
    return res
  }

  onChangeFilter = (f) => {
    return (v) => {
      v.preventDefault()
      const { activeFilters } = this.state
      const { selectedTemplateId, selectTemplate } = this.props
      const activeFiltersCopy = _.clone(activeFilters)
      const index = activeFiltersCopy.indexOf(f.id)
      if (index < 0) {
        activeFiltersCopy.push(f.id)
      } else {
        activeFiltersCopy.splice(index, 1)
      }
      const filteredTemplates = this.filterTemplates(activeFiltersCopy, this.props.templates)
      if (_.findIndex(filteredTemplates, t => t.id === selectedTemplateId) < 0) selectTemplate('')
      this.setState({
        activeFilters: activeFiltersCopy,
        templates: filteredTemplates
      })
    }
  }

  renderFilters () {
    const { activeFilters } = this.state
    return (
      <FiltersContainer>
        {filters.map(f =>
          <StyledCheckbox key={f.id}>
            <Checkbox
              checked={activeFilters.indexOf(f.id) > -1}
              onChange={this.onChangeFilter(f)}
            >
              {f.title}
            </Checkbox>
          </StyledCheckbox>
        )}
      </FiltersContainer>
    )
  }

  renderTemplates () {
    const { selectedTemplateId, selectTemplate } = this.props
    const { templates } = this.state
    return (
      <DashboardTab>
        {/* {this.renderFilters()} */}
        {templates.map(card => {
          if (!card.disabled) {
            return (
              <DashboardCard
                id={card.id}
                type='template'
                image={card.image}
                title={card.title}
                category={card.category}
                description={card.description}
                integrations={card.integrations}
                selected={selectedTemplateId === card.id}
                selectCard={selectTemplate}
                key={card.id}
              />
            )
          }
        })}
      </DashboardTab>
    )
  }

  onSelectTemplateType = (activeFilters) => {
    this.setState({
      activeFilters,
      templates: this.filterTemplates(activeFilters, this.props.templates),
      templatesTypeChoosen: true
    })
  }

  renderTemplatesTypes () {
    return (
      <TemplatesTypeSelector onClick={this.onSelectTemplateType} />
    )
  }

  render () {
    return this.renderTemplates()
    // if (this.state.templatesTypeChoosen) {
    //   return this.renderTemplates()
    // } else {
    //   return this.renderTemplatesTypes()
    // }
  }
}

TemplatesTab.defaultProps = {
  templates: [],
  selectedTemplateId: '',
  selectTemplate: () => null,
  activeFilters: [],
}

TemplatesTab.propTypes = {
  templates: PropTypes.array,
  selectedTemplateId: PropTypes.string,
  selectTemplate: PropTypes.func,
  activeFilters: PropTypes.array,
}

export default TemplatesTab



// WEBPACK FOOTER //
// ./src/components/dashboard/TemplatesTab.js